import React from 'react'
import Banner from './Banner'
import Featured from './Featured'
import Footer from './Footer'
import Arrays from './Arrays'





function AllHome() {
  return (
    <div>
     
       <Banner/>
       <Featured/>
     <Arrays/>
       <Footer/>
      
       
       
  
      

    </div>
  )
}

export default AllHome